import React, { useState, Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { useStateIfMounted } from 'use-state-if-mounted';
import { useDispatch, useSelector } from 'react-redux';
import {
    agregarMapFC_30Accion,
    actualizarFC_30Estatus, obtenerIdCliente,
    actualizarFC_30Solicitud, actualizarFC_30MapSolicitud,
    actualizarFC_30SolicitudMap, generarDocumentosFC_30,
    obtenerSolicitudDetalleFC_30ConMaps, aceptarSolicitudFC_30, actualizarFC_30Formulario
} from '../../../redux/DucksAtencionACliente/FC_30AtencionAClienteDucks';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { AcualizarFormatoAccion } from '../../../redux/AtencionAClienteDucks'
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import moment from 'moment'
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import TablaAtencionACliente from '../../App/TablaAtencionACliente';
import estilos from './AtencionAClientesFC_30Component.module.css'; { {/*Estilos para el componente*/ } }
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import TablaDocumentacion from '../../App/TablaDocumentacion';
const { useEffect, useRef } = React;
import FormularioDocumentacionFC_30 from '../../UsuarioAtencionACliente/FormularioFC30/FormularioDocumentacionFC_30';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
import { crearMetricas } from '../../../redux/DuckMetricas/MetricasDuck';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleCorrecto = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(90%, -35%)',
    width: 350,
    height: 450,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 3,
    p: 3,
    // background:'black',
    opacity: 1,
    'overflowY': 'scroll',
};
const styleIncorrecto = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(100%, -10%)',
    width: 330,
    height: 220,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 0,
    p: 3,
    'overflowY': 'scroll',
};
const styleDevolver = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
function FC_30Component(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)
    const dataUser = useSelector(store => store.Usuario.user)
    const tipoUsuario = useSelector(store => store.Usuario.tipoUsuario)
    let fc_30 = useSelector(store => store.FC_30SolicitudAtencionACliente.fc_30)
    let fc_30Productos = useSelector(store => store.FC_30SolicitudAtencionACliente.productos)
    let solicitud = useSelector(store => store.FC_30SolicitudAtencionACliente.data)
    console.log('detaplle ', solicitud)
    const formato = useSelector(store => store.AtencionSolicitud.formato)
    let fc_30Map = useSelector(store => store.FC_30SolicitudAtencionACliente.fc_30Map)
    let fc_30ProductosMap = useSelector(store => store.FC_30SolicitudAtencionACliente.productosMap)
    const idUsuario = usuario.data.user[0].id
    var fechaHoy = moment().format('YYYY-MM-DD');
    let filesProductosMap = useSelector(store => store.FC_30SolicitudAtencionACliente.filesProductosMap)
    /*Controlar las el formulario con las paginas*/
    const currentUser = useSelector(store => store.Usuario.data)
    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3, 4])
    const modoVerDetalle = useSelector(store => store.FC_30SolicitudAtencionACliente.modoVerDetalle)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos solicitante', 'Datos recepción', 'Características de productos', 'Documentación'])
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }
    let pagina1 = []
    let fecha = solicitud.fechapropuestaactividad.substring(0, 10)

    pagina1.push(
        {
            id: uuidv4(), Campo: 'Fecha de visita propuesta', valor: fecha, idfc30_notificaciontrasladodepr: solicitud.idfc30_notificaciontrasladodepr,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.fechapropuestaactividad : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.fechapropuestaactividadcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.fechapropuestaactividadcheck : false,
        },
        {
            id: uuidv4(), Campo: 'Responsable de instalación', valor: solicitud.responsabletraslado,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsabletraslado : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.responsabletrasladocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsabletrasladocheck : false,
        },)
    if (solicitud.otrainstalacion) {
        pagina1.push({
            id: uuidv4(), Campo: 'Traslado de producto a la misma empresa', valor: solicitud.otrainstalacion === true ? 'Si' : 'No',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.otrainstalacion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.otrainstalacioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.otrainstalacioncheck : false,
        },)
    }
    if (solicitud.paracomprayventa) {
        pagina1.push({
            id: uuidv4(), Campo: 'Traslado de producto para compra y venta', valor: solicitud.paracomprayventa === true ? 'Si' : 'No',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.paracomprayventa : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.paracomprayventacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.paracomprayventacheck : false,
        })
    }
    if (solicitud.superviciondocumental) {
        pagina1.push({
            id: uuidv4(), Campo: 'Supervisión documental', valor: solicitud.superviciondocumental === true ? 'Si' : 'No',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.superviciondocumental : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.superviciondocumentalcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.superviciondocumentalcheck : false,
        },)
    }
    if (solicitud.supervicionsitio) {
        pagina1.push({
            id: uuidv4(), Campo: 'Supervisión en sitio', valor: solicitud.supervicionsitio === true ? 'Si' : 'No',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.supervicionsitio : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.supervicionsitiocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.supervicionsitiocheck : false,
        },)
    }
    if (solicitud.propiasalida) {
        pagina1.push({
            id: uuidv4(), Campo: 'Salida de mi instalación', valor: solicitud.propiasalida === true ? 'Si' : 'No',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.propiasalida : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.propiasalidacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.propiasalidacheck : false,
        },)
    }
    if (solicitud.noregistradasalida) {
        pagina1.push({
            id: uuidv4(), Campo: 'Salida de una empresa no registrada', valor: solicitud.noregistradasalida === true ? 'Si' : 'No',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.noregistradasalida : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.noregistradasalidacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.noregistradasalidacheck : false,
        },)
    }
    if (solicitud.salida_propductor_maquilador) {
        pagina1.push({
            id: uuidv4(), Campo: 'Salida de una empresa registrada', valor: solicitud.salida_propductor_maquilador === true ? 'Si' : 'No',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.noregistradasalida : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.noregistradasalidacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.noregistradasalidacheck : false,
        },)
    }
    let cortar = solicitud.tipoinstalacionsalida.split('/')
    if (solicitud.propiasalida) pagina1.push(
        {
            id: uuidv4(), Campo: 'Tipo de instalación', valor: cortar[1] == '1' ? 'Unidad de producción' : cortar[1] == '2' ? 'Unidad de envasado' : 'Unidad de almacén',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.tipoinstalacionsalida : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.tipoinstalacionsalidacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.tipoinstalacionsalidacheck : false,
        },
        {
            id: uuidv4(), Campo: 'Responsable de la instalación', valor: solicitud.responsableinstalacionessolicit,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionessolicit : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.responsableinstalacionessolicitcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionessolicitcheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronicosolicitante,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicosolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.correoelectronicosolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicosolicitantecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefonosolicitante,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonosolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.telefonosolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonosolicitantecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Domicilio Completo', valor: solicitud.domiciliosolicitante,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliosolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.domiciliosolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliosolicitantecheck : false,
        }
    )
    if (solicitud.noregistradasalida) pagina1.push(
        {
            id: uuidv4(), Campo: 'Razón social', valor: solicitud.razonsocialsolicitante,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.razonsocialsolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.razonsocialsolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.razonsocialsolicitantecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Responsable de la instalación', valor: solicitud.responsableinstalacionessolicit,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionessolicit : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.responsableinstalacionessolicitcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionessolicitcheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronicosolicitante,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicosolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.correoelectronicosolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicosolicitantecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefonosolicitante,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonosolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.telefonosolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonosolicitantecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Domicilio Completo', valor: solicitud.domiciliosolicitante,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliosolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.domiciliosolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliosolicitantecheck : false,
        }
    )
    if (solicitud.salida_propductor_maquilador) pagina1.push(
        {
            id: uuidv4(), Campo: 'Número de cliente', valor: solicitud.numeroclientesolicitante,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.numeroclientesolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.numeroclientesolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.numeroclientesolicitantecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Tipo de instalación', valor: cortar[1] == '1' ? 'Unidad de producción' : cortar[1] == '2' ? 'Unidad de envasado' : 'Unidad de almacén',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.tipoinstalacionsalida : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.tipoinstalacionsalidacheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.tipoinstalacionsalidacheck : false,
        },
        {
            id: uuidv4(), Campo: 'Responsable de la instalación', valor: solicitud.responsableinstalacionessolicit,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionessolicit : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.responsableinstalacionessolicitcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionessolicitcheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronicosolicitante,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicosolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.correoelectronicosolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicosolicitantecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefonosolicitante,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonosolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.telefonosolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonosolicitantecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Domicilio Completo', valor: solicitud.domiciliosolicitante,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliosolicitante : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.domiciliosolicitantecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliosolicitantecheck : false,
        }
    )
    let [rowspagina1, setRowsPagina1] = React.useState(pagina1)
    let pagina2 = []
    if (solicitud.propiarecepcion) {
        pagina2.push(
            {
                id: uuidv4(), Campo: 'Recepción a instalación propia', valor: solicitud.propiarecepcion === true ? 'Si' : 'No',
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.propiarecepcion : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.propiarecepcioncheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.propiarecepcioncheck : false,
            }
        )
    }
    if (solicitud.otroclienterecepcion) {
        pagina2.push(
            {
                id: uuidv4(), Campo: 'Recepción a otro cliente del COMERCAM', valor: solicitud.otroclienterecepcion === true ? 'Si' : 'No',
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.otroclienterecepcion : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.otroclienterecepcioncheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.otroclienterecepcioncheck : false,
            },
        )
    }
    if (solicitud.noregistradarecepcion) {
        pagina2.push(
            {
                id: uuidv4(), Campo: 'Recepción a empresa no registrada en COMERCAM', valor: solicitud.noregistradarecepcion === true ? 'Si' : 'No',
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.noregistradarecepcion : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.noregistradarecepcioncheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.noregistradarecepcioncheck : false,
            }
        )
    }
    let cortar1 = solicitud.tipoinstalacionrecepcion.split('/')
    if (solicitud.propiarecepcion) pagina2.push(
        {
            id: uuidv4(), Campo: 'Tipo de instalación', valor: cortar1[1] == '1' ? 'Unidad de producción' : cortar1[1] == '2' ? 'Unidad de envasado' : 'Unidad de almacén',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.tipoinstalacionrecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.tipoinstalacionrecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.tipoinstalacionrecepcioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Responsable de la instalación', valor: solicitud.responsableinstalacionesrecepci,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionesrecepci : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.responsableinstalacionesrecepcicheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionesrecepcicheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronicorecepcion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicorecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.correoelectronicorecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicorecepcioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefonorecepcion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonorecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.telefonorecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonorecepcioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Domicilio Completo', valor: solicitud.domiciliorecepcion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliorecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.domiciliorecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliorecepcioncheck : false,
        }
    )
    if (solicitud.otroclienterecepcion || solicitud.numeroclienterecepcion || (solicitud?.salida_propductor_maquilador && !solicitud.propiarecepcion)) pagina2.push(
        {
            id: uuidv4(), Campo: 'Número de cliente', valor: solicitud.numeroclienterecepcion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.numeroclienterecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.numeroclienterecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.numeroclienterecepcioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Tipo de instalación', valor: cortar1[1] == '1' ? 'Unidad de producción' : cortar1[1] == '2' ? 'Unidad de envasado' : 'Unidad de almacén',
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.tipoinstalacionrecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.tipoinstalacionrecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.tipoinstalacionrecepcioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Responsable de la instalación', valor: solicitud.responsableinstalacionesrecepci,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionesrecepci : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.responsableinstalacionesrecepcicheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionesrecepcicheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronicorecepcion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicorecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.correoelectronicorecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicorecepcioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefonorecepcion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonorecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.telefonorecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonorecepcioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Domicilio Completo', valor: solicitud.domiciliorecepcion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliorecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.domiciliorecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliorecepcioncheck : false,
        }
    )
    if (solicitud.noregistradarecepcion) pagina2.push(
        {
            id: uuidv4(), Campo: 'Razón social', valor: solicitud.razonsocialrecepcion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.razonsocialrecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.razonsocialrecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.razonsocialrecepcioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Responsable de la instalación', valor: solicitud.responsableinstalacionesrecepci,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionesrecepci : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.responsableinstalacionesrecepcicheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.responsableinstalacionesrecepcicheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronicorecepcion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicorecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.correoelectronicorecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.correoelectronicorecepcioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefonorecepcion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonorecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.telefonorecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.telefonorecepcioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Domicilio Completo', valor: solicitud.domiciliorecepcion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliorecepcion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.domiciliorecepcioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.domiciliorecepcioncheck : false,
        }
    )
    pagina2.push({
        id: uuidv4(), Campo: 'Observaciones posteriores a la recepción', valor: solicitud.observaciones,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.observaciones : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? !fc_30Map?.observacionescheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_30Map) && JSON.stringify([]) !== JSON.stringify(fc_30Map) ? fc_30Map?.observacionescheck : false,
    })
    let [rowspagina2, setRowsPagina2] = React.useState(pagina2)

    let pagina3 = []
    let pagina4 = []
    if (solicitud.otrainstalacion) {
        for (const index in solicitud.fc_30_anexoproducto) {
            const { ...producto } = solicitud.fc_30_anexoproducto[index]
            let filtro = fc_30ProductosMap?.filter(anexo => anexo?.idfc30_anexoproducto === producto?.idfc30_anexoproducto)
            pagina3.push(
                {
                    id: uuidv4(), idfc30_anexoproducto: producto.idfc30_anexoproducto,
                    idfc30_anexoproductomap: filtro[0]?.idfc30_anexoproductomap ? filtro[0]?.idfc30_anexoproductomap : '',
                    numeroanalisis: producto.numeroanalisis,
                    contenidoalcoholico: producto.contenidoalcoholico,
                    numerocertificado: producto.numerocertificado,
                    numerolote: producto.numerolote,
                    volumen: producto.volumen,
                    observaciones: filtro[0] ? filtro[0].producto : '',
                    correcto: filtro[0] ? !filtro[0].productocheck : false,
                    incorrecto: filtro[0] ? filtro[0].productocheck : false,
                })
            let analisisLaboratorio = producto.numeroanalisis.split(',')
            let numeroCertificado = producto.numerocertificado.split(',')

            for (const i in analisisLaboratorio) {
                let nameid = `DPAL${index}${i}`.toString()
                const filtroAnalisis = solicitud.fc_30_anexoproducto[index].fc_30archivoproducto.filter(anexo => anexo.nameid === nameid)
                const filtroMapProductos = filesProductosMap?.filter(anexo => anexo?.idfc_30archivoproducto === filtroAnalisis?.[0]?.idfc_30archivoproducto)
                pagina4.push({
                    id: uuidv4(),
                    observaciones: filtroMapProductos?.[0]?.observacion ? filtroMapProductos?.[0]?.observacion : '',
                    correcto: filtroMapProductos?.[0] ? !filtroMapProductos?.[0]?.estatuscheck : false,
                    incorrecto: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.estatuscheck : false,
                    fechaInicio: filtroAnalisis?.[0]?.fechainicio ? filtroAnalisis?.[0]?.fechainicio : '',
                    fechaTermino: filtroAnalisis?.[0]?.fechafin ? filtroAnalisis?.[0]?.fechafin : '',
                    estatus: filtroAnalisis?.[0]?.estatus ? filtroAnalisis[0]?.estatus : 'Agregar',
                    idMap: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.idfc_30archivoproductomap : '',
                    idfc_30archivoproducto: filtroAnalisis?.[0]?.idfc_30archivoproducto,
                    tabla: 'fc_30archivoproducto', nombreId: 'idfc30_anexoproducto', idSolicitud: producto.idfc30_anexoproducto,
                    nameid: `DPAL${index}${i}`, nameDoc: 'Análisis de Laboratorio: ' + analisisLaboratorio[i]
                })
            }
            for (const i in numeroCertificado) {
                let nameid = `DPCA${index}${i}`.toString()
                const filtroCertificado = solicitud.fc_30_anexoproducto[index].fc_30archivoproducto.filter(anexo => anexo.nameid === nameid)
                const filtroMapProductos = filesProductosMap?.filter(anexo => anexo.idfc_30archivoproducto === filtroCertificado[0]?.idfc_30archivoproducto)
                pagina4.push({
                    id: uuidv4(),
                    observaciones: filtroMapProductos?.[0]?.observacion ? filtroMapProductos?.[0]?.observacion : '',
                    correcto: filtroMapProductos?.[0] ? !filtroMapProductos?.[0]?.estatuscheck : false,
                    incorrecto: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.estatuscheck : false,
                    fechaInicio: filtroCertificado?.[0]?.fechainicio ? filtroCertificado?.[0]?.fechainicio : '',
                    fechaTermino: filtroCertificado?.[0]?.fechafin ? filtroCertificado?.[0]?.fechafin : '',
                    estatus: filtroCertificado?.[0]?.estatus ? filtroCertificado?.[0]?.estatus : 'Agregar',
                    idMap: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.idfc_30archivoproductomap : '',
                    idfc_30archivoproducto: filtroCertificado?.[0]?.idfc_30archivoproducto,
                    tabla: 'fc_30archivoproducto', nombreId: 'idfc30_anexoproducto', idSolicitud: producto.idfc30_anexoproducto,
                    nameid: `DPCA${index}${i}`, nameDoc: 'Certificado NOM de producto a granel: ' + numeroCertificado[i]
                })
            }

        }
    } else {
        if (solicitud.otroclienterecepcion || solicitud.propiasalida || solicitud?.salida_propductor_maquilador) {
            for (const index in solicitud.fc_30_anexoproducto) {
                const { ...producto } = solicitud.fc_30_anexoproducto[index]
                let filtro = fc_30ProductosMap?.filter(anexo => anexo?.idfc30_anexoproducto === producto?.idfc30_anexoproducto)
                pagina3.push(
                    {
                        id: uuidv4(), idfc30_anexoproducto: producto.idfc30_anexoproducto,
                        idfc30_anexoproductomap: filtro[0]?.idfc30_anexoproductomap ? filtro[0]?.idfc30_anexoproductomap : '',
                        numeroanalisis: producto.numeroanalisis,
                        numerolote: producto.numerolote,
                        volumen: producto.volumen,
                        contenidoalcoholico: producto.contenidoalcoholico,
                        numerocertificado: producto.numerocertificado,
                        observaciones: filtro[0] ? filtro[0].producto : '',
                        correcto: filtro[0] ? !filtro[0].productocheck : false,
                        incorrecto: filtro[0] ? filtro[0].productocheck : false,
                    }
                )
                let analisisLaboratorio = producto.numeroanalisis.split(',')
                let numeroCertificado = producto.numerocertificado.split(',')

                for (const i in analisisLaboratorio) {
                    let nameid = `DPAL${index}${i}`.toString()
                    const filtroAnalisis = solicitud.fc_30_anexoproducto[index].fc_30archivoproducto.filter(anexo => anexo.nameid === nameid)
                    const filtroMapProductos = filesProductosMap?.filter(anexo => anexo.idfc_30archivoproducto === filtroAnalisis[0].idfc_30archivoproducto)
                    pagina4.push({
                        id: uuidv4(),
                        observaciones: filtroMapProductos?.[0]?.observacion ? filtroMapProductos?.[0]?.observacion : '',
                        correcto: filtroMapProductos?.[0] ? !filtroMapProductos?.[0]?.estatuscheck : false,
                        incorrecto: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.estatuscheck : false,
                        fechaInicio: filtroAnalisis?.[0]?.fechainicio ? filtroAnalisis?.[0]?.fechainicio : '',
                        fechaTermino: filtroAnalisis?.[0]?.fechafin ? filtroAnalisis?.[0]?.fechafin : '',
                        estatus: filtroAnalisis?.[0]?.estatus ? filtroAnalisis?.[0]?.estatus : 'Agregar',
                        idMap: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.idfc_30archivoproductomap : '',
                        idfc_30archivoproducto: filtroAnalisis?.[0]?.idfc_30archivoproducto,
                        tabla: 'fc_30archivoproducto', nombreId: 'idfc30_anexoproducto', idSolicitud: producto.idfc30_anexoproducto,
                        nameid: `DPAL${index}${i}`, nameDoc: 'Análisis de Laboratorio: ' + analisisLaboratorio[i]
                    })
                }
                for (const i in numeroCertificado) {
                    let nameid = `DPCA${index}${i}`.toString()
                    const filtroCertificado = solicitud.fc_30_anexoproducto[index].fc_30archivoproducto.filter(anexo => anexo.nameid === nameid)
                    const filtroMapProductos = filesProductosMap?.filter(anexo => anexo.idfc_30archivoproducto === filtroCertificado[0]?.idfc_30archivoproducto)
                    pagina4.push({
                        id: uuidv4(),
                        observaciones: filtroMapProductos?.[0]?.observacion ? filtroMapProductos?.[0]?.observacion : '',
                        correcto: filtroMapProductos?.[0] ? !filtroMapProductos?.[0]?.estatuscheck : false,
                        incorrecto: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.estatuscheck : false,
                        fechaInicio: filtroCertificado?.[0]?.fechainicio ? filtroCertificado?.[0]?.fechainicio : '',
                        fechaTermino: filtroCertificado?.[0]?.fechafin ? filtroCertificado?.[0]?.fechafin : '',
                        estatus: filtroCertificado?.[0]?.estatus ? filtroCertificado?.[0]?.estatus : 'Agregar',
                        idMap: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.idfc_30archivoproductomap : '',
                        idfc_30archivoproducto: filtroCertificado[0]?.idfc_30archivoproducto,
                        tabla: 'fc_30archivoproducto', nombreId: 'idfc30_anexoproducto', idSolicitud: producto.idfc30_anexoproducto,
                        nameid: `DPCA${index}${i}`, nameDoc: 'Certificado NOM de producto a granel: ' + numeroCertificado[i]
                    })
                }
            }
        } else {
            if (solicitud.noregistradarecepcion || solicitud.noregistradasalida) {
                for (const index in solicitud.fc_30_anexoproducto) {
                    const { ...producto } = solicitud.fc_30_anexoproducto[index]
                    let filtro = fc_30ProductosMap?.filter(anexo => anexo?.idfc30_anexoproducto === producto?.idfc30_anexoproducto)
                    pagina3.push(
                        {
                            id: uuidv4(), idfc30_anexoproducto: producto.idfc30_anexoproducto,
                            idfc30_anexoproductomap: filtro[0]?.idfc30_anexoproductomap ? filtro[0]?.idfc30_anexoproductomap : '',
                            numeroanalisis: producto.numeroanalisis,
                            numerolote: producto.numerolote,
                            volumen: producto.volumen,
                            contenidoalcoholico: producto.contenidoalcoholico,
                            numerocertificado: producto.numerocertificado,
                            observaciones: filtro[0] ? filtro[0].producto : '',
                            correcto: filtro[0] ? !filtro[0].productocheck : false,
                            incorrecto: filtro[0] ? filtro[0].productocheck : false,
                        }
                    )
                    let analisisLaboratorio = producto.numeroanalisis.split(',')
                    let numeroCertificado = producto.numerocertificado.split(',')

                    for (const i in analisisLaboratorio) {
                        let nameid = `DPAL${index}${i}`.toString()
                        const filtroAnalisis = solicitud.fc_30_anexoproducto[index].fc_30archivoproducto.filter(anexo => anexo.nameid === nameid)
                        const filtroMapProductos = filesProductosMap?.filter(anexo => anexo.idfc_30archivoproducto === filtroAnalisis[0].idfc_30archivoproducto)
                        pagina4.push({
                            id: uuidv4(),
                            observaciones: filtroMapProductos?.[0]?.observacion ? filtroMapProductos?.[0]?.observacion : '',
                            correcto: filtroMapProductos?.[0] ? !filtroMapProductos?.[0]?.estatuscheck : false,
                            incorrecto: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.estatuscheck : false,
                            fechaInicio: filtroAnalisis[0]?.fechainicio ? filtroAnalisis?.[0]?.fechainicio : '',
                            fechaTermino: filtroAnalisis[0]?.fechafin ? filtroAnalisis?.[0]?.fechafin : '',
                            estatus: filtroAnalisis?.[0]?.estatus ? filtroAnalisis[0]?.estatus : 'Agregar',
                            idMap: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.idfc_30archivoproductomap : '',
                            idfc_30archivoproducto: filtroAnalisis?.[0]?.idfc_30archivoproducto,
                            tabla: 'fc_30archivoproducto', nombreId: 'idfc30_anexoproducto', idSolicitud: producto.idfc30_anexoproducto,
                            nameid: `DPAL${index}${i}`, nameDoc: 'Análisis de Laboratorio: ' + analisisLaboratorio[i]
                        })
                    }
                    // let nameid = `DPII${index}`
                    // const filtroEtiqueta = solicitud.fc_30_anexoproducto[index].fc_30archivoproducto.filter(anexo => anexo.nameid === nameid)
                    // const filtroMapEtiqueta = filesProductosMap?.filter(anexo => anexo.idfc_30archivoproducto === filtroEtiqueta[0].idfc_30archivoproducto)
                    // pagina4.push({
                    //     id: uuidv4(),
                    //     observaciones: filtroMapEtiqueta?.[0]?.observacion ? filtroMapEtiqueta?.[0]?.observacion : '',
                    //     correcto: filtroMapEtiqueta?.[0] ? !filtroMapEtiqueta?.[0]?.estatuscheck : false,
                    //     incorrecto: filtroMapEtiqueta?.[0] ? filtroMapEtiqueta?.[0]?.estatuscheck : false,
                    //     fechaInicio: filtroEtiqueta?.[0]?.fechainicio ? filtroEtiqueta?.[0]?.fechainicio : '',
                    //     fechaTermino: filtroEtiqueta[0]?.fechafin ? filtroEtiqueta?.[0]?.fechafin : '',
                    //     estatus: filtroEtiqueta?.[0]?.estatus ? filtroEtiqueta?.[0]?.estatus : 'Agregar', 
                    //     idMap: filtroMapEtiqueta?.[0] ? filtroMapEtiqueta?.[0]?.idfc_30archivoproductomap : '',
                    //     idfc_30archivoproducto: filtroEtiqueta[0]?.idfc_30archivoproducto,
                    //     tabla: 'fc_30archivoproducto', nombreId: 'idfc30_anexoproducto', idSolicitud: producto.idfc30_anexoproducto,
                    //     nameid: `DPII${index}`, nameDoc: 'Informe de inspección'
                    // })
                    let nameidDictamen = `DPD${index}`
                    const filtroDictamen = solicitud.fc_30_anexoproducto[index].fc_30archivoproducto.filter(anexo => anexo.nameid === nameidDictamen)
                    const filtroMapDictamen = filesProductosMap?.filter(anexo => anexo.idfc_30archivoproducto === filtroDictamen[0].idfc_30archivoproducto)
                    pagina4.push({
                        id: uuidv4(),
                        observaciones: filtroMapDictamen?.[0]?.observacion ? filtroMapDictamen?.[0]?.observacion : '',
                        correcto: filtroMapDictamen?.[0] ? !filtroMapDictamen?.[0]?.estatuscheck : false,
                        incorrecto: filtroMapDictamen?.[0] ? filtroMapDictamen?.[0]?.estatuscheck : false,
                        fechaInicio: filtroDictamen?.[0]?.fechainicio ? filtroDictamen?.[0]?.fechainicio : '',
                        fechaTermino: filtroDictamen?.[0]?.fechafin ? filtroDictamen?.[0]?.fechafin : '',
                        estatus: filtroDictamen?.[0]?.estatus ? filtroDictamen?.[0]?.estatus : 'Agregar',
                        idMap: filtroMapDictamen?.[0] ? filtroMapDictamen?.[0]?.idfc_30archivoproductomap : '',
                        idfc_30archivoproducto: filtroDictamen?.[0]?.idfc_30archivoproducto,
                        tabla: 'fc_30archivoproducto', nombreId: 'idfc30_anexoproducto', idSolicitud: producto.idfc30_anexoproducto,
                        nameid: `DPD${index}`, nameDoc: 'Dictamen de cumplimiento con la NOM'
                    })

                    for (const i in numeroCertificado) {
                        let nameid = `DPCA${index}${i}`.toString()
                        const filtroCertificado = solicitud.fc_30_anexoproducto[index].fc_30archivoproducto.filter(anexo => anexo.nameid === nameid)
                        const filtroMapProductos = filesProductosMap?.filter(anexo => anexo.idfc_30archivoproducto === filtroCertificado[0]?.idfc_30archivoproducto)
                        pagina4.push({
                            id: uuidv4(),
                            observaciones: filtroMapProductos?.[0]?.observacion ? filtroMapProductos?.[0]?.observacion : '',
                            correcto: filtroMapProductos?.[0] ? !filtroMapProductos?.[0]?.estatuscheck : false,
                            incorrecto: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.estatuscheck : false,
                            fechaInicio: filtroCertificado?.[0]?.fechainicio ? filtroCertificado?.[0]?.fechainicio : '',
                            fechaTermino: filtroCertificado?.[0]?.fechafin ? filtroCertificado?.[0]?.fechafin : '',
                            estatus: filtroCertificado?.[0]?.estatus ? filtroCertificado?.[0]?.estatus : 'Agregar',
                            idMap: filtroMapProductos?.[0] ? filtroMapProductos?.[0]?.idfc_30archivoproductomap : '',
                            idfc_30archivoproducto: filtroCertificado?.[0]?.idfc_30archivoproducto,
                            tabla: 'fc_30archivoproducto', nombreId: 'idfc30_anexoproducto', idSolicitud: producto.idfc30_anexoproducto,
                            nameid: `DPCA${index}${i}`, nameDoc: 'Certificado NOM de producto a granel: ' + numeroCertificado[i]
                        })
                    }
                }

            }
        }

    }

    let [rowspagina3, setRowsPagina3] = React.useState(pagina3)
    let [rowspagina4, setRowsPagina4] = React.useState(pagina4)
    let columns = []
    if (solicitud.otrainstalacion === true) {
        columns = [
            {
                field: 'numerocertificado', headerName: 'No. de certificado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.numerocertificado}`} arrow>
                            <label>{`${params.row.numerocertificado} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            {
                field: 'numeroanalisis', headerName: 'Analisis de laboratorio', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.numeroanalisis}`} arrow>
                            <label>{`${params.row.numeroanalisis} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            {
                field: 'numerolote', headerName: 'No. de lote', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.numerolote}`} arrow>
                            <label>{`${params.row.numerolote} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            { field: 'volumen', headerName: 'Volumen', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1, },
            {
                field: 'contenidoalcoholico', headerName: 'Alc. Vol.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.contenidoalcoholico}`} arrow>
                            <label>{`${params.row.contenidoalcoholico} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            {
                field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .5,
                renderCell: (params) =>
                (
                    <Fragment>
                        <button className={params.row.correcto ? ('btn btn-success ms-1') : ('btn btn-outline-success ms-1')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                        <button className={params.row.incorrecto ? ('btn btn-danger ms-2') : ('btn btn-outline-danger ms-2')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                    </Fragment>
                )
            },
        ]
    } else {
        columns = [
            {
                field: 'numeroanalisis', headerName: 'Analisis de laboratorio', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.numeroanalisis}`} arrow>
                            <label>{`${params.row.numeroanalisis} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            {
                field: 'numerolote', headerName: 'No. de lote', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.numerolote}`} arrow>
                            <label>{`${params.row.numerolote} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            { field: 'volumen', headerName: 'Volumen', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1, },
            {
                field: 'contenidoalcoholico', headerName: 'Alc. Vol.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.contenidoalcoholico}`} arrow>
                            <label>{`${params.row.contenidoalcoholico} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            {
                field: 'numerocertificado', headerName: 'No. de certificado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
                renderCell: (params) =>
                (
                    <div>
                        <Tooltip title={`${params.row.numerocertificado}`} arrow>
                            <label>{`${params.row.numerocertificado} `}</label>
                        </Tooltip>
                    </div>
                )
            },
            {
                field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .5,
                renderCell: (params) =>
                (
                    <Fragment>
                        <button className={params.row.correcto ? ('btn btn-success ms-1') : ('btn btn-outline-success ms-1')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                        <button className={params.row.incorrecto ? ('btn btn-danger ms-2') : ('btn btn-outline-danger ms-2')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                    </Fragment>
                )
            },
        ]
    }
    const handdleEditPrev = (objectProducto) => {
        const filtroSalida = rowspagina1.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroRecepcion = rowspagina2.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroProducto = rowspagina3.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDocumentacion = rowspagina4.findIndex(anexo => anexo.id === objectProducto.id)
        if (filtroSalida !== -1) {
            rowspagina1[filtroSalida].valor = objectProducto.valor
            rowspagina1[filtroSalida].correcto = objectProducto.correcto
            rowspagina1[filtroSalida].incorrecto = objectProducto.incorrecto
            rowspagina1[filtroSalida].observaciones = objectProducto.observaciones
        }
        if (filtroRecepcion !== -1) {
            rowspagina2[filtroRecepcion].valor = objectProducto.valor
            rowspagina2[filtroRecepcion].correcto = objectProducto.correcto
            rowspagina2[filtroRecepcion].incorrecto = objectProducto.incorrecto
            rowspagina2[filtroRecepcion].observaciones = objectProducto.observaciones
        }
        if (filtroProducto !== -1) {
            rowspagina3[filtroProducto].valor = objectProducto.valor
            rowspagina3[filtroProducto].correcto = objectProducto.correcto
            rowspagina3[filtroProducto].incorrecto = objectProducto.incorrecto
            rowspagina3[filtroProducto].observaciones = objectProducto.observaciones
        }
        if (filtroDocumentacion !== -1) {
            rowspagina4[filtroDocumentacion].correcto = objectProducto.correcto
            rowspagina4[filtroDocumentacion].incorrecto = objectProducto.incorrecto
            rowspagina4[filtroDocumentacion].observaciones = objectProducto.observaciones
            rowspagina4[filtroDocumentacion].fechaInicio = objectProducto.fechaInicio
            rowspagina4[filtroDocumentacion].fechaTermino = objectProducto.fechaTermino
        }
    }
    const [campo, setCampo] = React.useState('')
    const [valor, setValor] = React.useState('')
    const [observaciones, setObservaciones] = React.useState('')
    const [correcto, setCorrecto] = React.useState('')
    const [incorrecto, setIncorrecto] = React.useState('')
    const [id, setId] = React.useState('')
    const [rowSeleccionada, setRowSeleccionada] = React.useState(false)
    const [openModalCorrecto, setOpenModalCorrecto] = React.useState(false);
    const [documentacion, setDocumentacion] = React.useState('')
    const [estadoVigencia, setEstadoVigencia] = React.useState('')
    const [fechaInicio, setFechaInicio] = React.useState('')
    const [fechaTermino, setFechaTermino] = React.useState('')
    const [vigencia, setVigencia] = React.useState(false);
    const handleOpenModalCorrecto = (params) => {
        setId(params.row.id)
        setCorrecto(true)
        setIncorrecto(false)
        setCampo(params.row.Campo)
        setObservaciones(params.row.observaciones)
        setOpenModalCorrecto(true)
        setValor(params.row.valor)
        setFechaInicio((params.row.fechaInicio !== null && params.row.fechaInicio !== '') ? (params.row.fechaInicio) : '')
        setFechaTermino((params.row.fechaTermino !== null && params.row.fechaTermino !== '') ? (params.row.fechaTermino) : '')
        setEstadoVigencia((params.row.estatus !== null && params.row.estatus !== undefined) ? params.row.estatus : 'Agregar')
        if (params.row.tabla) {
            setRowSeleccionada(true)
            setValor(params.row.nameDoc)
        }
    }
    const handleCloseModalCorrecto = () => {
        setFechaInicio('')
        setFechaTermino('')
        setEstadoVigencia('')
        setOpenModalCorrecto(false)
        setVigencia(false)
        setRowSeleccionada(false)
    }
    const modalComponentCorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalCorrecto}
                    onClose={handleCloseModalCorrecto}
                    hideBackdrop={true}

                >
                    <Box sx={styleCorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ color: 'black' }}>
                            <div className="form-floating mb-3" color='black'>
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" style={{ height: "80px" }} value={valor} onChange={e => setValor(e.target.value)} />
                                {/* <input type="text" className={`form-control `} id="floatinginput" placeholder='Campo' value={valor} onChange={e => setValor(e.target.value)} /> */}
                                <label htmlFor="floatingInput">Campo</label>
                            </div>
                            <div className="form-floating mb-3">
                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                                <label htmlFor="floatingInput">Observaciones</label>
                            </div>
                            <br /><br />

                        </Typography>
                        <br />

                        {modoVerDetalle ?
                            <div className='row'>
                                <div className={` text-center`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CERRAR</button>
                                </div>
                            </div>
                            :
                            <div className='row'>
                                <div className='col-md-6'>
                                    <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                                </div>
                                <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CANCELAR</button>
                                </div>
                            </div>
                        }
                    </Box>
                </Modal>
            </div >
        )
    }
    const [openModalIncorrecto, setOpenModalIncorrecto] = React.useState(false);
    const handleOpenModalIncorrecto = (params) => {
        setId(params.row.id)
        setIncorrecto(true)
        setCorrecto(false)
        setCampo(params.row.Campo)
        setValor(params.row.valor)
        setObservaciones(params.row.observaciones)
        setOpenModalIncorrecto(true)
    }
    const handleCloseModalIncorrecto = () => {
        setOpenModalIncorrecto(false)

    }
    const modalComponentIncorrecto = () => {
        return (
            <div>
                <Modal
                    open={openModalIncorrecto}
                    onClose={handleCloseModalIncorrecto}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleIncorrecto}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0 }} className='text-center'>
                            <label className='text-center'>Observaciones</label>
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"
                                value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                        </Typography>
                        <br />

                        {modoVerDetalle ?
                            <div className='row'>
                                <div className={` text-center`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CERRAR</button>
                                </div>
                            </div>
                            :
                            <div className='row'>
                                <div className='col-md-6'>
                                    <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                                </div>
                                <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                    <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CANCELAR</button>
                                </div>
                            </div>
                        }
                    </Box>
                </Modal>
            </div>
        )
    }
    const botonGuardar = () => {
        let datos = { id: id, campo: campo, correcto: correcto, incorrecto: incorrecto, observaciones: observaciones, valor: valor }
        handdleEditPrev(datos)
        handleCloseModalCorrecto(true)
        handleCloseModalIncorrecto(true)
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_30())
    }
    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModalDeDocumentos}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            Para finalizar el trámite ingrese los siguientes datos
                        </Typography>
                        <FormularioDocumentacionFC_30
                            functionAcept={botonAceptarSolicitud}
                        ></FormularioDocumentacionFC_30>
                        <br />
                    </Box>
                </Modal>
            </div>

        )
    }
    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_30Map) || JSON.stringify([]) === JSON.stringify(fc_30Map) || fc_30Map === null) {
            await agregarMapYActualizarFC_30()
            const idSolicitud = solicitud.idfc30_notificaciontrasladodepr
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_30 = 5
            const tabla = tablaFC_30
            await dispatch(actualizarFC_30Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_30()
            const idSolicitud = solicitud.idfc30_notificaciontrasladodepr
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_30 = 5
            const tabla = tablaFC_30
            await dispatch(actualizarFC_30Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')

    }
    const agregarMapYActualizarFC_30 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        /*if (solicitud.propia) {
            principal.push({
                idfc33_solicitudenvasadonaciona: rowsServicioSolicitado[0].idfc33_solicitudenvasadonaciona,
                domicilioproducto: rowsServicioSolicitado[1].valor, resposableinstalaciones: rowsServicioSolicitado[2].valor,
                telefono: rowsServicioSolicitado[3].valor, correoelectronico: rowsServicioSolicitado[4].valor,
                informacionadicionalsobreactivi: rowsServicioSolicitado[9].valor, fechasolicitud: fechaSolicitudAceptada
            })
        }*/
        let principalMap = []
        for (const i in rowspagina1) {
            let { ...datos } = rowspagina1[i]
            if (datos.Campo == 'Fecha de visita propuesta') principalMap.push({ fechapropuestaactividad: datos.observaciones, fechapropuestaactividadcheck: datos.incorrecto })
            if (datos.Campo == 'Responsable de instalación') principalMap.push({ responsabletraslado: datos.observaciones, responsabletrasladocheck: datos.incorrecto })
            if (datos.Campo == 'Traslado de producto a la misma empresa') principalMap.push({ otrainstalacion: datos.observaciones, otrainstalacioncheck: datos.incorrecto })
            if (datos.Campo == 'Traslado de producto para compra y venta') principalMap.push({ paracomprayventa: datos.observaciones, paracomprayventacheck: datos.incorrecto })
            if (datos.Campo == 'Supervisión documental') principalMap.push({ superviciondocumental: datos.observaciones, superviciondocumentalcheck: datos.incorrecto })
            if (datos.Campo == 'Supervisión en sitio') principalMap.push({ supervicionsitio: datos.observaciones, supervicionsitiocheck: datos.incorrecto })
            if (datos.Campo == 'Salida de mi instalación') principalMap.push({ propiasalida: datos.observaciones, propiasalidacheck: datos.incorrecto })
            if (datos.Campo == 'Salida de una empresa no registrada') principalMap.push({ noregistradasalida: datos.observaciones, noregistradasalidacheck: datos.incorrecto })
            if (datos.Campo == 'Tipo de instalación') principalMap.push({ tipoinstalacionsalida: datos.observaciones, tipoinstalacionsalidacheck: datos.incorrecto })
            if (datos.Campo == 'Responsable de la instalación') principalMap.push({ responsableinstalacionessolicit: datos.observaciones, responsableinstalacionessolicitcheck: datos.incorrecto })
            if (datos.Campo == 'Correo electrónico') principalMap.push({ correoelectronicosolicitante: datos.observaciones, correoelectronicosolicitantecheck: datos.incorrecto })
            if (datos.Campo == 'Teléfono') principalMap.push({ telefonosolicitante: datos.observaciones, telefonosolicitantecheck: datos.incorrecto })
            if (datos.Campo == 'Domicilio Completo') principalMap.push({ domiciliosolicitante: datos.observaciones, domiciliosolicitantecheck: datos.incorrecto })
            if (datos.Campo == 'Razón social') principalMap.push({ razonsocialsolicitante: datos.observaciones, razonsocialsolicitantecheck: datos.incorrecto })
        }
        principalMap.push({
            idfc30_notificaciontrasladodepr: solicitud.idfc30_notificaciontrasladodepr,
        })

        for (const i in rowspagina2) {
            let { ...datos } = rowspagina2[i]
            if (datos.Campo == 'Recepción a instalación propia') principalMap.push({ propiarecepcion: datos.observaciones, propiarecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Recepción a otro cliente del COMERCAM') principalMap.push({ otroclienterecepcion: datos.observaciones, otroclienterecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Recepción a empresa no registrada en COMERCAM') principalMap.push({ noregistradarecepcion: datos.observaciones, noregistradarecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Tipo de instalación') principalMap.push({ tipoinstalacionrecepcion: datos.observaciones, tipoinstalacionrecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Responsable de la instalación') principalMap.push({ responsableinstalacionesrecepci: datos.observaciones, responsableinstalacionesrecepcicheck: datos.incorrecto })
            if (datos.Campo == 'Correo electrónico') principalMap.push({ correoelectronicorecepcion: datos.observaciones, correoelectronicorecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Teléfono') principalMap.push({ telefonorecepcion: datos.observaciones, telefonorecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Domicilio Completo') principalMap.push({ domiciliorecepcion: datos.observaciones, domiciliorecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Número de cliente') principalMap.push({ numeroclienterecepcion: datos.observaciones, numeroclienterecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Razón social') principalMap.push({ razonsocialrecepcion: datos.observaciones, razonsocialrecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Observaciones posteriores a la recepción') principalMap.push({ observaciones: datos.observaciones, observacionescheck: datos.incorrecto })
        }
        let obj_unidos = {}
        for (const i in principalMap) {
            obj_unidos = Object.assign(obj_unidos, principalMap[i])
        }

        let productosMap = []
        for (const producto of rowspagina3) {
            productosMap.push({ idfc30_anexoproductomap: producto.idfc30_anexoproductomap, producto: producto.observaciones, productocheck: producto.incorrecto, idfc30_anexoproducto: producto.idfc30_anexoproducto })
        }
        let archivosProductosMap = []
        for (const anexo in rowspagina4) {
            let nameid = ''
            if (rowspagina4[anexo]?.nameid?.substring(0, 3) === 'DPD') nameid = rowspagina4[anexo]?.nameid?.substring(0, 3)
            else nameid = rowspagina4[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPII" || nameid == "DPD") {
                archivosProductosMap.push({
                    idfc_30archivoproductomap: rowspagina4[anexo] ? rowspagina4[anexo]?.idMap : '',
                    estatuscheck: rowspagina4[anexo]?.incorrecto, observacion: rowspagina4[anexo]?.observaciones,
                    idfc_30archivoproducto: rowspagina4[anexo]?.idfc_30archivoproducto,
                })
            }
        }

        let archivosProductos = []
        for (const anexo in rowspagina4) {
            let nameid = ''
            if (rowspagina4[anexo]?.nameid?.substring(0, 3) === 'DPD') nameid = rowspagina4[anexo]?.nameid?.substring(0, 3)
            else nameid = rowspagina4[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPII" || nameid == "DPD") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowspagina4[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina4[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowspagina4[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina4[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosProductos.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_30archivoproducto: rowspagina4[anexo]?.idfc_30archivoproducto
                })
            }
        }
        let formato = { solicitud: principal[0], archivosProductos: archivosProductos }
        let formatoMap = { solicitud: obj_unidos, productosMap: productosMap, archivosProductosMap: archivosProductosMap }
        await dispatch(agregarMapFC_30Accion(formatoMap))
        //await dispatch(actualizarFC_30Solicitud(formato))
        return
    }
    const actualizarMapYActualizarFC_30 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        /*if (solicitud.propia) {
            principal.push({
                idfc33_solicitudenvasadonaciona: rowsServicioSolicitado[0].idfc33_solicitudenvasadonaciona,
                domicilioproducto: rowsServicioSolicitado[1].valor, resposableinstalaciones: rowsServicioSolicitado[2].valor,
                telefono: rowsServicioSolicitado[3].valor, correoelectronico: rowsServicioSolicitado[4].valor,
                informacionadicionalsobreactivi: rowsServicioSolicitado[9].valor, fechasolicitud: fechaSolicitudAceptada
            })
        }*/
        let principalMap = []
        for (const i in rowspagina1) {
            let { ...datos } = rowspagina1[i]
            if (datos.Campo == 'Fecha de visita propuesta') principalMap.push({ fechapropuestaactividad: datos.observaciones, fechapropuestaactividadcheck: datos.incorrecto })
            if (datos.Campo == 'Responsable de instalación') principalMap.push({ responsabletraslado: datos.observaciones, responsabletrasladocheck: datos.incorrecto })
            if (datos.Campo == 'Traslado de producto a la misma empresa') principalMap.push({ otrainstalacion: datos.observaciones, otrainstalacioncheck: datos.incorrecto })
            if (datos.Campo == 'Traslado de producto para compra y venta') principalMap.push({ paracomprayventa: datos.observaciones, paracomprayventacheck: datos.incorrecto })
            if (datos.Campo == 'Supervisión documental') principalMap.push({ superviciondocumental: datos.observaciones, superviciondocumentalcheck: datos.incorrecto })
            if (datos.Campo == 'Supervisión en sitio') principalMap.push({ supervicionsitio: datos.observaciones, supervicionsitiocheck: datos.incorrecto })
            if (datos.Campo == 'Salida de mi instalación') principalMap.push({ propiasalida: datos.observaciones, propiasalidacheck: datos.incorrecto })
            if (datos.Campo == 'Salida de una empresa no registrada') principalMap.push({ noregistradasalida: datos.observaciones, noregistradasalidacheck: datos.incorrecto })
            if (datos.Campo == 'Tipo de instalación') principalMap.push({ tipoinstalacionsalida: datos.observaciones, tipoinstalacionsalidacheck: datos.incorrecto })
            if (datos.Campo == 'Responsable de la instalación') principalMap.push({ responsableinstalacionessolicit: datos.observaciones, responsableinstalacionessolicitcheck: datos.incorrecto })
            if (datos.Campo == 'Correo electrónico') principalMap.push({ correoelectronicosolicitante: datos.observaciones, correoelectronicosolicitantecheck: datos.incorrecto })
            if (datos.Campo == 'Teléfono') principalMap.push({ telefonosolicitante: datos.observaciones, telefonosolicitantecheck: datos.incorrecto })
            if (datos.Campo == 'Domicilio Completo') principalMap.push({ domiciliosolicitante: datos.observaciones, domiciliosolicitantecheck: datos.incorrecto })
            if (datos.Campo == 'Razón social') principalMap.push({ razonsocialsolicitante: datos.observaciones, razonsocialsolicitantecheck: datos.incorrecto })
        }
        principalMap.push({
            idfc30_notificaciontrasladodepr: solicitud.idfc30_notificaciontrasladodepr,
            idfc30_notificaciontrasladodeprmap: fc_30Map.idfc30_notificaciontrasladodeprmap,
        })

        for (const i in rowspagina2) {
            let { ...datos } = rowspagina2[i]
            if (datos.Campo == 'Recepción a instalación propia') principalMap.push({ propiarecepcion: datos.observaciones, propiarecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Recepción a otro cliente del COMERCAM') principalMap.push({ otroclienterecepcion: datos.observaciones, otroclienterecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Recepción a empresa no registrada en COMERCAM') principalMap.push({ noregistradarecepcion: datos.observaciones, noregistradarecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Tipo de instalación') principalMap.push({ tipoinstalacionrecepcion: datos.observaciones, tipoinstalacionrecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Responsable de la instalación') principalMap.push({ responsableinstalacionesrecepci: datos.observaciones, responsableinstalacionesrecepcicheck: datos.incorrecto })
            if (datos.Campo == 'Correo electrónico') principalMap.push({ correoelectronicorecepcion: datos.observaciones, correoelectronicorecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Teléfono') principalMap.push({ telefonorecepcion: datos.observaciones, telefonorecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Domicilio Completo') principalMap.push({ domiciliorecepcion: datos.observaciones, domiciliorecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Número de cliente') principalMap.push({ numeroclienterecepcion: datos.observaciones, numeroclienterecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Razón social') principalMap.push({ razonsocialrecepcion: datos.observaciones, razonsocialrecepcioncheck: datos.incorrecto })
            if (datos.Campo == 'Observaciones posteriores a la recepción') principalMap.push({ observaciones: datos.observaciones, observacionescheck: datos.incorrecto })
        }
        let obj_unidos = {}
        for (const i in principalMap) {
            obj_unidos = Object.assign(obj_unidos, principalMap[i])
        }

        let productosMap = []
        for (const producto of rowspagina3) {
            productosMap.push({ idfc30_anexoproductomap: producto.idfc30_anexoproductomap, producto: producto.observaciones, productocheck: producto.incorrecto, idfc30_anexoproducto: producto.idfc30_anexoproducto })
        }
        let archivosProductosMap = []
        for (const anexo in rowspagina4) {
            let nameid = ''
            if (rowspagina4[anexo]?.nameid?.substring(0, 3) === 'DPD') nameid = rowspagina4[anexo]?.nameid?.substring(0, 3)
            else nameid = rowspagina4[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPII" || nameid == "DPD") {
                archivosProductosMap.push({
                    idfc_30archivoproductomap: rowspagina4[anexo]?.idMap ? rowspagina4[anexo]?.idMap : '',
                    estatuscheck: rowspagina4[anexo]?.incorrecto, observacion: rowspagina4[anexo]?.observaciones,
                    idfc_30archivoproducto: rowspagina4[anexo]?.idfc_30archivoproducto,
                })
            }
        }

        let archivosProductos = []
        for (const anexo in rowspagina4) {
            let nameid = ''
            if (rowspagina4[anexo]?.nameid?.substring(0, 3) === 'DPD') nameid = rowspagina4[anexo]?.nameid?.substring(0, 3)
            else nameid = rowspagina4[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DPAL" || nameid === "DPCA" || nameid === "DPII" || nameid == "DPD") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowspagina4[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina4[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowspagina4[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina4[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosProductos.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_30archivoproducto: rowspagina4[anexo]?.idfc_30archivoproducto
                })
            }
        }
        let formato = { solicitud: principal[0], archivosProductos: archivosProductos }
        let formatoMap = { solicitud: obj_unidos, productosMap: productosMap, archivosProductosMap: archivosProductosMap }
        await dispatch(actualizarFC_30SolicitudMap(formatoMap))
        //await dispatch(actualizarFC_30Solicitud(formato))
        return
    }
    const botonAceptarSolicitud = async (dataForm) => {

        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_30Map) || JSON.stringify([]) === JSON.stringify(fc_30Map) || fc_30Map === null) {
            await agregarMapYActualizarFC_30()
        } else {
            await actualizarMapYActualizarFC_30()
        }
        let dataMetricas = {
            estatus_procedencia: "Solicitudes Recibidas Procedentes",
            id_solicitud: "6", id_usuario: dataUser?.[0].idlogin,
            motivo: "Cargado automatico del sistema",
            fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
            numero_cliente: solicitud?.numerocliente,
            numero_solicitud: dataForm?.numeroSolicitud, origen: "Sistema"
        }
        await dispatch(crearMetricas(dataMetricas))
        const dataSolicitudFC_30 = await dispatch(obtenerSolicitudDetalleFC_30ConMaps(solicitud.idfc30_notificaciontrasladodepr))
        const solicitudParaAceptar = dataSolicitudFC_30.payload
        const dataCliente = await dispatch(obtenerClienteByIdLogin(solicitud.idlogin))
        const objetoCompleto = {
            idcliente: dataCliente?.payload?.cliente?.[0]?.idcliente,
            idfc30_notificaciontrasladodepr: solicitud.idfc30_notificaciontrasladodepr,
            productos: solicitudParaAceptar.fc_30_anexoproducto
        }
        await dispatch(aceptarSolicitudFC_30(objetoCompleto))

        let informacionmodalaceptada = {
            numerosolicitudservicios: dataForm?.numeroSolicitud, numcertificadonom: dataForm?.numCertificadoNOM,
            numerotraslado: dataForm?.numeroTraslado, otrosservicios: dataForm?.otrosServicios,
            fechainspeccion: dataForm?.fechaInspeccion,
            numeroplanevaluacion: dataForm?.numeroPlanEvaluacion,
            inspectorasignado: dataForm?.inspectorAsignado, credencialinspector: dataForm?.credencialInspector,
            telefonoinspector: dataForm?.telefonoInspector

        }
        let modal = {
            idfc30_notificaciontrasladodepr: solicitud.idfc30_notificaciontrasladodepr, informacionmodalaceptada: informacionmodalaceptada,
            fechapropuestaactividad: new Date(dataForm?.fechaInspeccion).toISOString()
        }
        await (dispatch(actualizarFC_30Formulario(modal)))

        await generarOficios(solicitud, dataCliente.payload.cliente[0], dataForm)
        const idSolicitud = solicitud.idfc30_notificaciontrasladodepr
        const estatusNuevo = 4
        const idCliente = null
        const tablaFC_30 = 5
        const tabla = tablaFC_30
        await dispatch(actualizarFC_30Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
        ))
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const generarOficios = async (solicitudFC_30, dataCliente, dataForm) => {
        const data = {
            tipoSolicitud: 'FC_30',
            solicitudFC_30,
            dataCliente,
        }
        const dataSolicitudInspeccion = {
            numeroSolicitud: dataForm.numeroSolicitud,
            numCertificadoNOM: dataForm.numCertificadoNOM,
            numeroTraslado: dataForm.numeroTraslado,
            otrosServicios: dataForm.otrosServicios,
            fechaInspeccion: dataForm.fechaInspeccion,
            numeroPlanEvaluacion: dataForm.numeroPlanEvaluacion,
            inspectorAsignado: dataForm.inspectorAsignado,
            credencialInspector: dataForm.credencialInspector,
            telefonoInspector: dataForm.telefonoInspector,
            checkFabrica: false,
            checkProductor: false,
            checkNacional: false,
            checkEnvasadora: false,
            checkEnvasador: false,
            checkExportacion: false,
            checkGranel: false,
            checkComercializador: false,
            checkPromocion: false,
            checkProductoTerminado: false,
            checkTraslado: true,
            checkMaduracion: false,
        }
        data.dataSolicitudInspeccion = dataSolicitudInspeccion
        await dispatch(generarDocumentosFC_30(data))
    }
    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = (params) => {
        setOpenModalDevolver(true)
    }
    const handleCloseModalDevolver = () => {
        setOpenModalDevolver(false)

    }
    const modalComponentDevolver = () => {
        return (
            <div>
                <Modal
                    open={openModalDevolver}
                    onClose={handleCloseModalDevolver}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleDevolver}>

                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>¡Advertencia!</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p>Está a punto de devolver esta solicitud.
                                Las observaciones seran enviadas al cliente para correcciones.</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />

                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonDevolverSolicitud() }}>CONTINUAR</button>
                            </div>
                            <div className={`${estilos.botonCancelarModal} col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDevolver() }}>CANCELAR</button>
                            </div>
                        </div>

                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {
                nombresParaPaginas[paginaActiva - 1] === 'Datos solicitante' ?
                    <div className='row justify-content-center'>
                        <div className='col-10'>
                            <TablaAtencionACliente rows={rowspagina1} api={{ handdleEditPrev }}></TablaAtencionACliente>
                        </div>
                    </div> :
                    nombresParaPaginas[paginaActiva - 1] === 'Datos recepción' ?
                        <div className='row justify-content-center'>
                            <div className='col-10'>
                                <TablaAtencionACliente rows={rowspagina2} api={{ handdleEditPrev }}></TablaAtencionACliente>
                            </div>
                        </div>
                        :
                        nombresParaPaginas[paginaActiva - 1] === 'Características de productos' ?
                            <div className='row justify-content-center'>
                                <div className='col-10'>
                                    <div style={{ height: (130 + (rowspagina3?.length * 50)), width: '99%', color: 'black' }}>
                                        <DataGrid
                                            rows={rowspagina3}
                                            columns={columns}

                                            sx={{
                                                boxShadow: 0,
                                                color: 'black',
                                                border: 0,
                                                '& .MuiDataGrid-cell': {
                                                    display: 'block',
                                                    position: 'relative',
                                                    textAlign: 'center',
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                            </div> :
                            nombresParaPaginas[paginaActiva - 1] === 'Documentación' ?
                                <Fragment>
                                    <div className='row justify-content-center'>
                                        <div className='col-12' style={{ marginLeft: '7%' }}>
                                            <TablaDocumentacion rows={rowspagina4} api={{ handdleEditPrev }}></TablaDocumentacion>
                                        </div>
                                    </div>
                                    {modoVerDetalle ?
                                        <div className="row text-center">
                                            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                            </div>
                                        </div>
                                        :
                                        <div className="row text-center mt-4 mb-4">
                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalAceptar} >Aceptar solicitud</button>
                                            </div>

                                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                            </div>
                                        </div>
                                    }
                                </Fragment> : ''
            }
            {modalComponentAceptar()}
            {modalComponentCorrecto()}
            {modalComponentIncorrecto()}
            {modalComponentDevolver()}
        </Fragment>
    )
}
export default withRouter(FC_30Component)
